/**
 * File Labels Tour
 *
 * Walkthrough for the file labels configuration page.
 * Shows users how to set up document classification labels.
 */

import { TourDefinition } from '../config/tourSteps';

export const fileLabelsTour: TourDefinition = {
  id: 'fileLabelsTour',
  steps: [
    {
      element: '[data-tour="file-labels-table"]',
      popover: {
        title: 'Bestandslabels Overzicht',
        description:
          'Hier ziet u alle beschikbare bestandslabels. Elk label representeert een type document dat de AI kan herkennen, zoals Factuur, Contract, Tekening, Vergunning, etc.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="add-file-label"]',
      popover: {
        title: 'Label Toevoegen',
        description:
          'Klik hier om een nieuw bestandslabel aan te maken. U kunt aangepaste labels definiëren voor specifieke documenttypen die relevant zijn voor uw organisatie.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="ai-analysis-toggle"]',
      popover: {
        title: 'AI-Analyse Inschakelen',
        description:
          'Schakel AI-analyse in voor labels waarbij u wilt dat de AI automatisch informatie extraheert. Bijvoorbeeld: bij facturen kan de AI leverancier, bedrag en datum extraheren.',
        side: 'left',
        align: 'center',
      },
    },
    {
      element: '[data-tour="extraction-rules"]',
      popover: {
        title: 'Extractie Configuratie',
        description:
          'Definieer welke velden de AI moet extraheren uit documenten met dit label. Voorbeelden: datum, bedrag, partijnaam, adres, referentienummer. De AI leert deze patronen herkennen.',
        side: 'top',
        align: 'start',
      },
    },
  ],
};
